import banners from '@gin-betting/banners';
import core from '@gin-betting/core';
import favoriteMarkets from '@gin-betting/favorite-markets';
import { Reducer, ReducersMapObject } from 'redux';

import { AppStateRecord } from 'app-constants';
import favorite from 'modules/favorite';
import matchList from 'modules/match-list';
import promo from 'modules/promo';
import ui from 'modules/ui';
import { AsyncStateShape, FullStateShape, State, SyncStateShape } from 'types';

const {
    entities,
    utils: { logReducerTiming, combineReducers },
} = core;

const stubReducer = (state = null) => state;

export default function createRootReducer(reducers: any): Reducer<State> {
    const appStateShape: ReducersMapObject = logReducerTiming({
        ...getInitialReducers(),
        ...reducers,
    });

    return combineReducers(appStateShape, AppStateRecord);
}

function getInitialReducers() {
    const asyncInitialReducers: Record<
        keyof AsyncStateShape,
        typeof stubReducer
    > = {
        viewport: stubReducer,
        betslip: stubReducer,
        filters: stubReducer,
        match: stubReducer,
        freebet: stubReducer,
        stream: stubReducer,
    };

    const syncInitialReducers: {
        [K in keyof Omit<SyncStateShape, 'viewport'>]: Reducer<
            SyncStateShape[K]
        >;
    } = {
        [entities.constants.NAME]: entities.reducer,
        [ui.constants.NAME]: ui.reducer,
        [favoriteMarkets.constants.NAME]: favoriteMarkets.reducer(),
        [matchList.constants.NAME]: matchList.reducer(),
        [matchList.pagination.constants.NAME]: matchList.paginationReducer(),
        [favorite.constants.NAME]: favorite.reducer,
        [banners.constants.NAME]: banners.reducer,
        [promo.constants.NAME]: promo.reducer,
    };

    const initialReducers: {
        [K in keyof FullStateShape]?: Reducer<any>;
    } = {
        ...asyncInitialReducers,
        ...syncInitialReducers,
    };

    return initialReducers;
}
